import { DEFAULT_CITY } from '../../shared/cities/index.ts';
import { pageMetaForPath } from '../../shared/seo/pages.ts';

/**
 * Titre de page + balises <title>/<meta> (hissées dans <head> par React 19).
 * Mêmes textes que ceux injectés par le Worker : un seul registre (shared/seo/pages.ts).
 */
export function PageHeader({ path, showHeading = true }: { path: string; showHeading?: boolean }) {
  const meta = pageMetaForPath(path, DEFAULT_CITY);
  if (meta === null) return null;
  return (
    <>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      {!meta.indexable && <meta name="robots" content="noindex" />}
      {showHeading && (
        <header className="page-header">
          <h1 className="page-title">{meta.heading}</h1>
          <p className="page-intro">{meta.intro}</p>
        </header>
      )}
    </>
  );
}
